module.exports = __webpack_public_path__ + "images/dir-small@2x-702c314b54ba8f8be70b85d6bd772d04.png";